import { ComponentSingleStyleConfig } from '@chakra-ui/theme/dist/types/theme.types';

export const MenuButton: ComponentSingleStyleConfig = {
  variants: {
    'chakraSelect.MenuButton': {
      _active: { bg: 'gray.50', borderColor: 'gray.300' },
      _focus: { borderColor: 'gray.200' },
      _hover: { bg: 'gray.50' },
      bg: 'none',
      borderWidth: 1,
      borderRadius: 8,
      borderColor: 'gray.300',
      textAlign: 'left',
      pl: 2,
      pr: 2,
      pt: 2,
      pb: 2,
      h: 'auto',
    },
  },
};
